import { ActiveChannelRequest } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getPresetActiveChannels = async (presetId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offer-presets/${presetId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetPresetActiveChannels = ({ presetId = '', enabled }: { presetId?: string; enabled: boolean }) => {
  return useGenericQuery<ActiveChannelRequest, RequestError>(
    ['preset-channels-by-id', presetId],
    () => getPresetActiveChannels(presetId),
    {
      enabled,
    }
  );
};
